import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconIphoneDuo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconIphoneDuo"><Path fillRule="evenodd" clipRule="evenodd" d="M17 2C18.6569 2 20 3.34315 20 5V19C20 20.6569 18.6569 22 17 22H4V2H17ZM15.25 5.5C14.5596 5.5 14 6.05964 14 6.75C14 7.44036 14.5596 8 15.25 8C15.9404 8 16.5 7.44036 16.5 6.75C16.5 6.05964 15.9404 5.5 15.25 5.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconIphoneDuo;
